import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import ChannelSection from "@/pages/home/components/ChannelSection";
import CategorySection from "@/pages/home/components/CategorySection";
import FeaturedLeads from "@/pages/home/components/FeaturedLeads";
import ProcessSection from "@/pages/home/components/ProcessSection";
import PrinciplesSection from "@/pages/home/components/PrinciplesSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  useSeo({
    title: "直曝 · 网络爆料投稿平台 | 匿名投稿·私信·邮箱线索直达编辑",
    description:
      "直曝是专注匿名线索收集的网络爆料投稿平台，提供在线投稿表单、匿名后台私信与编辑邮箱三条通道，全程保护投稿人隐私。消费维权、职场内幕、行业观察、民生身边事、网络乱象、公益求助，一条线索也能直达编辑视野。",
    keywords:
      "网络爆料,网络爆料投稿,网络爆料匿名,网络爆料私信,网络爆料邮箱,网络爆料后台,网络爆料线索",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.fullName,
        alternateName: "直曝",
        url: "https://wzwzww.cn/",
        email: siteInfo.email,
        description: siteInfo.intro,
        foundingDate: siteInfo.since,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.fullName,
        url: "https://wzwzww.cn/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://wzwzww.cn/leads?keyword={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 5).map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <>
      <HeroSection />
      <ChannelSection />
      <CategorySection />
      <FeaturedLeads />
      <ProcessSection />
      <PrinciplesSection />
      <TestimonialsSection />
      <FaqPreview />
      <CtaSection />
    </>
  );
}